<script>
import Vue from 'vue';
import { Popover } from 'element-ui';

Vue.use(Popover);

export default {
    props: {
        placement: {
            type: String,
            default: 'top-start'
        },

        trigger: {
            type: String,
            default: 'hover'
        },

        width: {
            type: String,
            default: null
        },

        title: {
            type: String,
            default: null
        },

        content: {
            type: String,
            default: null
        },

        truncate: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<template>
    <div>
        <el-popover
            ref="popover"
            :placement="placement"
            :title="title"
            :width="width"
            :trigger="trigger"
            :content="content"
        >
            <div :class="{'p-b-0 b-r-3 no-wrap': true, 'truncate-md': truncate, 'd-flex': !truncate}" slot="reference">
                <slot name="reference">
                    {{content}}
                </slot>
            </div>

            <slot>
                {{content}}
            </slot>
            <template v-if="!$slots.default && !content">
                --
            </template>
        </el-popover>
    </div>
</template>